type Size = 'small' | 'medium' | 'large'

const SIZE_CLASSES: Record<Size, string> = {
  small: 'h-12 w-12 text-[1.1rem]',
  medium: 'h-24 w-24 text-[2.2rem]',
  large: 'h-36 w-36 text-[3.2rem]',
}

const DOT_CLASSES: Record<Size, string> = {
  small: 'h-3 w-3 right-0 bottom-0 border-2',
  medium: 'h-5 w-5 right-1 bottom-1 border-[3px]',
  large: 'h-7 w-7 right-2 bottom-2 border-4',
}

type Props = {
  name: string
  color: string
  size?: Size
  online?: boolean
  animate?: boolean
  className?: string
}

/**
 * Human-style companion avatar: solid-color circle with the companion's
 * initial, like a messaging-app contact, plus an "online" presence dot.
 */
export default function CompanionAvatar({
  name,
  color,
  size = 'medium',
  online = true,
  animate = true,
  className = '',
}: Props) {
  return (
    <div className={`relative inline-block ${className}`}>
      <div
        className={`flex items-center justify-center rounded-full font-serif text-white shadow-[0_8px_30px_rgba(43,34,48,0.18)] ${SIZE_CLASSES[size]}`}
        style={{
          background: color,
          animation: animate ? 'avatarBreathe 4s ease-in-out infinite' : 'none',
        }}
      >
        {name.charAt(0).toUpperCase()}
      </div>
      {online && (
        <span
          className={`absolute rounded-full border-white bg-[#4BBF8A] ${DOT_CLASSES[size]}`}
          style={{ animation: 'onlinePulse 2.5s ease-in-out infinite' }}
        />
      )}
    </div>
  )
}
